import { Injectable } from '@angular/core';
import { KeyValue } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CompareService {
  /***
   * Compares provided map1 and map2 arguments
   * and return true if they are equal
   * otherwise false
   * @param map1 - first map
   * @param map2 - second map
   */
  mapsEqual(map1: Map<any, any>, map2: Map<any, any>): boolean {
    return (
      JSON.stringify(Array.from(map1.entries())) === JSON.stringify(Array.from(map2.entries()))
    );
  }

  compareFn(path: string) {
    return (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
      const valA = (this.getNestedValue(a, path) || '').toString().trim();
      const valB = (this.getNestedValue(b, path) || '').toString().trim();

      const caseInsensitiveComparison = valA.toLowerCase().localeCompare(valB.toLowerCase());
      if (caseInsensitiveComparison !== 0) {
        return caseInsensitiveComparison;
      }

      return valA.localeCompare(valB, undefined, { caseFirst: 'upper' });
    };
  }

  getNestedValue<T>(obj: T, path: string): unknown {
    return path
      .split('.')
      .reduce(
        (acc: unknown, part: string) => (acc as Record<string, unknown>)?.[part],
        obj as unknown,
      );
  }
}
